import React, { forwardRef } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList } from 'react-window';

import { useIsMobile } from 'common/hooks/useIsMobile';

import ListItemsRowRenderer from './VirtualizedListRowRenderer/VirtualizedListRowRenderer';
import { virtualizedListConfig } from './VirtualizedListRowRenderer/virtualizedListConfig';
import { ListRowMenuItemProps } from './types';

export type MenuItemsTabProps = {
  items: ListRowMenuItemProps[];
};

export const VirtualizedListMenuItems = forwardRef<VariableSizeList, MenuItemsTabProps>(({ items }, ref) => {
  const isMobile = useIsMobile();

  return (
    <AutoSizer key={isMobile ? 'mobile' : 'desktop'} disableWidth style={{ height: '100%' }}>
      {({ height }) => (
        <VariableSizeList
          ref={ref}
          width="100%"
          height={height}
          itemSize={index => virtualizedListConfig[items[index].type].getRowHeight(items[index])}
          itemData={items}
          itemCount={items.length}
          overscanCount={2}
        >
          {ListItemsRowRenderer}
        </VariableSizeList>
      )}
    </AutoSizer>
  );
});
